<template>
  <div class="send-record">
    <div class="main-title">
      <p @click="toList">电池管理</p>
      <p>>查看电池里程</p>
    </div>
    <div class="main-body">
      <div class="list">
        <span>用户手机号：</span>
        <el-input class="list-input" size="mini" v-model="phone"></el-input>
        <span class="ml10">换出电池通讯板编号：</span>
        <el-input class="list-input" size="mini" v-model="communicationBoardNo"></el-input>
      </div>
      <div class="list">
        <span>时间：</span>
        <el-date-picker
          v-model="startTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          placeholder="开始日期">
        </el-date-picker>
        --
        <el-date-picker
          v-model="endTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          placeholder="结束日期">
        </el-date-picker>
        <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
        <div class="normal-btn ml10" @click="downloadBtnClick">导出</div>
      </div>
      <table class="table-custom">
        <thead>
        <tr>
          <th>用户编号</th>
          <th>用户手机号</th>
          <th>换出电池<br/>通讯板编号</th>
          <th>换出订单<br/>编号</th>
          <th width="80px">换出时间</th>
          <th width="80px">换入时间</th>
          <th>换入订单<br/>编号</th>
          <th>换出到换<br/>入里程</th>
          <th>换出电量</th>
          <th>换入电量</th>
          <th>换出到换入<br/>消耗电量</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="item,index in dataList" :key="index">
          <td>{{ item.userAccountNo }}</td>
          <td>{{ item.userPhone }}</td>
          <td>{{ item.swapOutCommunicationBoardNo }}</td>
          <td>{{ item.swapOutOrderNo }}</td>
          <td>{{ item.swapOutTime }}</td>
          <td>{{ item.swapInTime }}</td>
          <td>{{ item.swapInOrderNo }}</td>
          <td>{{ item.orderMileage }}</td>
          <td>{{ item.swapOutElectricityQuantity }}</td>
          <td>{{ item.swapInElectricityQuantity }}</td>
          <td>{{ item.consumeElectricityQuantity }}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan='11'>暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="pre-btn" :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">上一页</div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">下一页</div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from "../../utils/utils";
            
export default {
  name: 'batteryMileage',
  data() {
    return {
      phone: '',
      startTime: '',
      endTime: '',
      pageSize: 10,
      beginIndex: 0,
      preBtnDisabled: true,
      nextBtnDisabled: false,
      communicationBoardNo: '',
      dataList: [],
      searchCondition: '',
      belongTarget: '',
      targetNumber: '',
      belongTargetSeq: '',
      version: '',
      status: '',
      manufacturer: '',
      listBeginIndex: 0
    }
  },
  mounted() {
    this.startTime = Utils.getCurrentDate() + " 00:00";
    this.endTime = Utils.getCurrentDate() + " 23:59";
    this.queryBatteryMileage();
    if (this.$route.query.searchCondition) {
      this.searchCondition = this.$route.query.searchCondition;
    }
    if (this.$route.query.belongTarget) {
      this.belongTarget = this.$route.query.belongTarget;
    }
    if (this.$route.query.targetNumber) {
      this.targetNumber = this.$route.query.targetNumber;
    }
    if (this.$route.query.belongTargetSeq) {
      this.belongTargetSeq = this.$route.query.belongTargetSeq;
    }
    if (this.$route.query.version) {
      this.version = this.$route.query.version;
    }
    if (this.$route.query.status) {
      this.status = this.$route.query.status;
    }
    if (this.$route.query.manufacturer) {
      this.manufacturer = this.$route.query.manufacturer;
    }
    if (this.$route.query.beginIndex) {
      this.listBeginIndex = this.$route.query.beginIndex;
    }
  },
  methods: {
    queryBatteryMileage() {
      let self = this;
      let params = {
        userPhone: this.phone,
        communicationBoardNo: this.communicationBoardNo,
        startTime: this.startTime,
        endTime: this.endTime,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1
      };
      this.$http.post('/managementPlatform/electricity/queryBatteryMileage', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.dataList = res.ldata;
        self.resetPreAndNextBtn(self.dataList.length);
        self.dataList.length > self.pageSize && self.dataList.pop();
      }).catch(function (response) {
        console.log(response);
      });
    },
    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.queryBatteryMileage();
    },
    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.queryBatteryMileage();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.queryBatteryMileage();
    },
    downloadBtnClick() {
      let self = this;
      let params = {
        userPhone: this.phone,
        communicationBoardNo: this.communicationBoardNo,
        startTime: this.startTime,
        endTime: this.endTime,
      };
      this.$http.post("/managementPlatform/electricity/batteryMileageExport", this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          })
          return;
        }
        self.$message({
          type: "success",
          message: "导出成功",
          center: true
        })
        setTimeout(function () {
          self.$router.push('/managePage/downloadTask')
        }, 1000)
      }).catch(function (response) {

      });
    },
    toList() {
      this.$router.push('/managePage/batteryMgmt?searchCondition=' + this.searchCondition + "&belongTarget=" + this.belongTarget + "&targetNumber=" + this.targetNumber
        + "&belongTargetSeq=" + this.belongTargetSeq + "&version=" + this.version + "&status=" + this.status + "&manufacturer=" + this.manufacturer + "&beginIndex=" + this.listBeginIndex)
    }
  },
}
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}

.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/batteryMileage.vue